import { render } from "./BorderedInput.vue?vue&type=template&id=76016c2b&ts=true"
import script from "./BorderedInput.vue?vue&type=script&lang=ts"
export * from "./BorderedInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__